const LOGIN_METHOD_USERNAME = 'app/login/method/username';
const LOGIN_METHOD_PROFILE_TEMP = 'app/login/method/profile_temp';

export { LOGIN_METHOD_USERNAME, LOGIN_METHOD_PROFILE_TEMP };
